<div class="container">
  <div class="form-group mt-3">
    <span class="font-bold">Month</span>
    <span class="d-block w-50">
      <input autocomplete="off" class="datetimepicker form-control" type="text" />
    </span>
  </div>

  <div class="form-group form-check mt-3 flex-direction">
    <input type="checkbox" class="form-check-input" id="runForAll" [(ngModel)]="formData.runForAll"
      (ngModelChange)="onRunForAllChange()" />
    <label class="form-check-label" for="runForAll">Run for all accounts</label>
  </div>

  <div class="form-group mt-3" *ngIf="!formData.runForAll">
    <select class="selectpicker" multiple data-live-search="true" data-width="100%" [disabled]="formData.runForAll"
      [(ngModel)]="formData.master_account_ids" id="masterAccountSelect" title="Select accounts...">
      <option *ngFor="let acc of allAccountsList" [value]="acc.master_accountid">
        {{ acc.account_name }} - {{ acc.master_accountid }}
      </option>
    </select>
  </div>


</div>

<div class="text-end mt-4">
  <button class="btn btn-primary" (click)="process()">
    Trigger Process
  </button>
</div>